import ModalOuterContainer from '../generic/containers/ModalOuterContainer';
import Typography from 'components/shared/generic/typography/presentational/Typography';
import useTranslate from 'lib/languages/useTranslate';
import AppStoreBadges from '../../layout/loginTemplate/presentational/AppStoreBadges';
import Button from 'components/shared/generic/button/presentational/Button';

const DownloadAppModal = ({closeModal}) => {
    const translate = useTranslate('loginWeb');

    return (
        <ModalOuterContainer customButtons={true}>
            <div className="description">
                <Typography tag="h1">{translate('downloadApp')}</Typography>
            </div>
            <div className="app-store-badges-wrapper">
                <AppStoreBadges />
            </div>
            <Button className="closeBtn" onClick={closeModal}>
                {translate("buttonCancel")}
            </Button>
        </ModalOuterContainer>
    );
};

export default DownloadAppModal;
